"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
require("./DropdownMenu.css");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DropdownMenu = exports.DropdownMenu = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var className = _ref.className,
    menuClassName = _ref.menuClassName,
    _ref$alignMenu = _ref.alignMenu,
    alignMenu = _ref$alignMenu === void 0 ? 'center' : _ref$alignMenu,
    items = _ref.items,
    trigger = _ref.trigger,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'bottom' : _ref$side,
    open = _ref.open,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange,
    showArrow = _ref.showArrow,
    _ref$itemSize = _ref.itemSize,
    itemSize = _ref$itemSize === void 0 ? 'compact' : _ref$itemSize,
    menuWidth = _ref.menuWidth;
  var triggerElement = !trigger ? /*#__PURE__*/_react.default.createElement("span", null, "...") : typeof trigger === 'string' ? /*#__PURE__*/_react.default.createElement("span", null, trigger) : trigger;
  return /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.Root, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.Trigger, {
    className: (0, _classnames.default)(className, 'zui-dropdown-trigger')
  }, triggerElement), /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.DropdownMenuPortal, null, /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.Content, {
    className: (0, _classnames.default)(menuClassName, 'zui-dropdown-menu'),
    align: alignMenu,
    side: side,
    ref: ref,
    style: {
      width: menuWidth
    }
  }, alignMenu === 'center' && showArrow && /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.Arrow, {
    className: "zui-dropdown-arrow"
  }), items.map(item => /*#__PURE__*/_react.default.createElement(_reactDropdownMenu.Item, {
    className: (0, _classnames.default)('zui-dropdown-item', item.className, itemSize),
    key: item.id,
    onSelect: event => item.onSelect(event)
  }, item.label)))));
});
//# sourceMappingURL=DropdownMenu.js.map